<template lang="pug">
    .index
        .left.box(v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)")
            .cards(ref="cards")
                el-steps.steps(:space="200" :active="active" finish-status="success" )
                    el-step(title="选择兴趣区")
                    el-step(title="选择商品")
                    el-step(title="选择规格")
                    el-step(title="支付方式")
                    el-step(title="支付订单")
                .btns
                    el-button(size="medium" @click="active --" :disabled="active <= 0 || active > 3") 上一步
                    el-button(size="medium" @click="nextStep" :disabled="active > 3") 下一步

            el-button.drawing-button(@click="drawing = !drawing" size="mini" v-if="active == 0")
                i.el-icon-add-location
                | {{ drawing ? '停止' : '开始' }}绘制
            Search.poi-search(@select="changeLocation" v-if="active == 0")
            .map-container(:style="{paddingBottom: active == 0 ? '500px' : 0}")
                Map(@aoiUpdated="aoiUpdated" v-if="active == 0" :location="location" :drawing="drawing")

            .goods-list(v-if="active == 1")
                //- el-radio-group.order(v-model="goodsId")
                el-card.card(v-for="item in goodsList" @click.native="goodsId = item.id" :key="item.id")
                    .product
                        img.thumb(v-if="item.simple_image" :src="item.simple_image")
                        h3
                            span 商品名称：{{item.name}} &nbsp;
                            el-radio(:value="goodsId" :label="item.id") &nbsp;
                        p(v-if="item.description") 商品描述：{{item.description}}
                        p(v-if="item.free") 单价：限时免费中 &nbsp;
                            s &yen;{{(item.amount / 100).toFixed(2)}}/平方公里
                        p(v-else) 单价：&yen;{{(item.amount / 100).toFixed(2)}}/平方公里
                        p 最小起订单位：{{item.area_min}} 平方公里
                        p(v-if="item.free") 预期单期价格：限时免费中 &nbsp;
                            s  预期单期价格：&yen;{{(chargeArea * (item.amount / 100)).toFixed(2)}}
                        p(v-else) 预期单期价格：&yen;{{(chargeArea * (item.amount / 100)).toFixed(2)}}

            div(v-if="active == 2")
                el-form.form
                    el-form-item(label="影像获取频率" required)
                        el-radio-group.order(v-model="frequency" required)
                            el-radio(v-for="(item, index) in goods.frequency" :key="item" :label="item") {{goods.frequency_cn[index]}}
                    el-form-item(label="影像期数" required)
                        el-input-number(v-model="num" :min="3" :max="24" required)
                    el-form-item(label="名称" required)
                        el-input(v-model="name" placeholder="请输入名称" require)
                    el-form-item(label="描述")
                        el-input(type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入描述" v-model="description")

            div(v-if="active == 3" )
                el-form
                    el-form-item(label="请选择支付方式")
                        el-radio-group.order(v-model="payType")
                            el-radio(label="wepay" border) 微信支付

                    el-form-item(label="请选择优惠券" v-if="coupons && coupons.length")
                        el-radio-group.coupon-list(v-model="couponId")
                            el-radio(v-for="item in coupons" :label="item.id" border) 优惠券ID：{{item.id}} 金额：&yen;{{(item.amount / 100).toFixed(2)}} 截止时间：{{new Date(item.expired_at * 1000).toLocaleString()}}

            .coupon.tc(v-if="active == 4 && payType == 'wepay'")
                p 订单金额 &yen;{{(order.amount_total / 100).toFixed(2)}}
                Wepay(:orderId="order.order_id" :payUrl="order.pay_url" @success="paySuccess")
                p 使用微信扫码支付

            .success(v-if="active > 5")
                i.el-icon-circle-check
                p 创建成功
                .success-btns
                    router-link.mr20(to="/aoiindex")
                        el-button 查看兴趣区
                    router-link(to="/stock")
                        el-button(type="primary") 去关联股票

        .right.msg-box.box
            dl
                dt 面积
                dd {{area && (area / 1e6).toFixed(2) || 0}} 平方公里
                dd(v-if="chargeArea") (实际以 {{chargeArea}} 平方公里计费)
            //- dl
            //-     dt 价格
            //-     dd &yen; 0.00
</template>

<script>
import storeMixin from '../store/mixin';
import Map from '../components/map/index.vue';
import area from '@turf/area';
import Search from '../components/map/search.vue';
import Wepay from '../components/wepay.vue';

export default {
    components: { Map, Search, Wepay },
    mixins: [storeMixin],
    name: 'Aoi',
    data() {
        return {
            active: 0,
            geojson: null,
            area: 0,
            drawing: false,
            payType: 'wepay',
            coupons: null,
            couponId: null,
            loading: false,
            name: null,
            description: null,
            location: null,
            goodsList: null,
            goodsId: null,
            order: null,
            frequency: null,
            num: 12,
        };
    },
    computed: {
        chargeArea() {
            if (!this.area) return 0;
            const chargeArea =
                this.area % 5e5 == 0
                    ? this.area
                    : (Math.floor(this.area / 5e5) + 1) * 5e5;
            return (chargeArea / 1e6).toFixed(2);
        },
        goods() {
            if (!this.goodsList || !this.goodsList.length || !this.goodsId)
                return null;
            return this.goodsList.find(goods => goods.id == this.goodsId);
        },
    },
    methods: {
        changeLocation(location) {
            this.location = location;
        },

        aoiUpdated(collection) {
            this.geojson = JSON.parse(JSON.stringify(collection));
            this.area = area(collection).toFixed(2);
        },
        async getCoupons() {
            if (this.loading) return;
            this.loading = true;
            try {
                const result = await this.REQUEST({ url: 'v2/coupon/list' });
                this.coupons = result.data.items || [];
            } catch (e) {
                console.log(e);
            }
            this.loading = false;
        },
        async createAoi() {
            if (this.loading) return;
            this.loading = true;
            try {
                const { data } = await this.REQUEST({
                    url: 'v2/aoi',
                    method: 'POST',
                    body: JSON.stringify({
                        name: this.name || '',
                        description: this.description || '',
                        coupon_id: this.couponId,
                        goods_id: this.goodsId,
                        geometry_geojson: JSON.stringify(
                            this.geojson.features[0].geometry
                        ),
                        goods_quantity: this.num,
                        goods_frequency: this.frequency,
                    }),
                });
                if (data && data.order_id) {
                    this.order = data;
                }
            } catch (e) {
                console.log(e);
            }
            this.loading = false;
        },
        async getGoods() {
            if (this.loading) return;
            this.loading = true;
            try {
                const result = await this.REQUEST({
                    url: 'v2/goods/list',
                });
                this.goodsList = result.data.items;
            } catch (e) {
                console.log(e);
            }
            this.loading = false;
        },
        async nextStep() {
            switch (this.active) {
                case 0:
                    // if (this.area < 5e5) {
                    //     this.$message({
                    //         message: '兴趣区不能小于0.5平方公里',
                    //         type: 'warning',
                    //     });
                    //     return;
                    // }
                    if (this.area > 1e7) {
                        this.$message({
                            message: '兴趣区不能大于10平方公里',
                            type: 'warning',
                        });
                        return;
                    }
                    if (this.geojson && this.area) {
                        this.active++;
                        this.getGoods();
                    } else {
                        this.$message({
                            message: '您尚未选取兴趣区',
                            type: 'warning',
                        });
                    }
                    break;
                case 1:
                    if (!this.goodsId) {
                        this.$message({
                            message: '请选择商品类型',
                            type: 'warning',
                        });
                        return;
                    }
                    this.active++;
                    // 预设频率
                    this.frequency = this.goods.frequency[0];
                    this.getCoupons();
                    break;
                case 2:
                    if (!this.name) {
                        this.$message({
                            message: '请填写兴趣区名称',
                            type: 'warning',
                        });
                        return;
                    }
                    this.active++;
                    if (this.goods.free) {
                        this.nextStep();
                    }
                    break;
                case 3:
                    await this.createAoi();
                    if (this.$route.query.code && this.order.aoi_id)
                        await this.createLink(
                            this.order.aoi_id,
                            this.$route.query.code
                        );

                    if (this.order.pay_url) {
                        this.active++;
                    } else {
                        this.active = 6;
                    }

                    break;
                case 4:
                    break;
                default:
                    this.active++;
            }
        },
        async createLink(aoiId, code) {
            await this.REQUEST({
                url: 'v2/aoi/relation',
                method: 'POST',
                body: JSON.stringify({
                    aoi_id: aoiId,
                    type: 'stock',
                    value: code,
                }),
            });
        },
        paySuccess() {
            this.active += 2;
        },
    },
    created() {
        console.log('created');
    },
    mounted() {},
};
</script>

<style lang="stylus" scoped>
.index
    display flex
    width 100%
.left
    flex-shrink 1
    flex-grow 1
    position relative
.cards
    width calc(100% - 40px)
    display flex
    align-items center
    justify-content space-between
    margin 0 40px 40px 0
    padding 20px
.steps
    width 500px
    background #1e1f25

.right
    width 300px
    margin-left 40px
.msg-box
    padding 20px 0
    dl
        margin 0 20px 20px 20px
    dt
        font-size 1.2rem
        border-bottom 1px solid #252631
        padding-bottom 10px
        margin-bottom 10px
    dd
        color #767a8c
        font-size 0.9rem
.success
    text-align center
    color #67C23A
    font-size 2em
    i
        font-size 200px

.mr20
    margin-right 20px

.poi-search, .drawing-button
    position absolute
    z-index 10
    right 30px
    top 180px
    width 100px
.drawing-button
    left 30px
.map-container
    position relative
.card
    margin-bottom 15px
    cursor pointer
    h3
        display flex
        justify-content space-between
.thumb
    width 200px
    margin-right 20px
    float left
.product
    overflow hidden
.form
    max-width 350px
.coupon-list
    display flex
    flex-direction column
    label
        margin 0 0 10px 10px
</style>
